import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
`;

export const Trigger = styled.div`
  margin-top: 4px;
  border: 1px solid #fff;
  color: #fff;
  opacity: 0.2;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 10px;
  height: 25px;
  background-color: var(--panels-bk-color);
  line-height: 25px;
  padding: 0 20px;

  &:hover {
    background-color: #555;
  }
`;
